import Api from "~/service/Api";

class Immersive3dTourReplacePanoramaProcessRepository {
  update(tourId, data) {
    return Api.post(`/immersive-3d-tour/replace-panorama-processes/${tourId}`, data);
  }
}

export default Immersive3dTourReplacePanoramaProcessRepository;
